import { APIConfig } from "@/lib/api";
import { ApiError } from "@/lib/api/api-error";
import { request as __request } from "@/lib/api/request";
import { getCsrfToken } from "@/providers/auth";
import { supplierSchema } from "./types/suppliers";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export class SupplierService {
  static async getSupplier(supplierId: number) {
    try {
      const data = await __request(
        APIConfig,
        {
          method: "GET",
          url: "/api/v1/orders/supplier/{supplierId}/",
          path: {
            supplierId: supplierId.toString(),
          },
          headers: {
            "X-CSRFToken": getCsrfToken() ?? "",
          },
        },
        supplierSchema,
      );
      return data;
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[getSupplier] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[getSupplier] Unexpected error:", error);
      }
      return null;
    }
  }
}
